import React, { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import {
  NqubeStage, AthenaStage, ListenStage, DevOpsStage, DevConsoleStage, AppBuilderStage, ReviewCard,
} from '../components/ModuleStages';
import { AMBIENT_SCREENS } from '../components/ambient';
import { GatePanel, TIMELINE } from '../components/landing/SpineRun';
import ReceiptCard from '../components/landing/ReceiptCard';

// The 3D rooms under simulated data (?room=app | fleet); lazy so the
// stage captures below keep their first paint.
const RoomFixtures = lazy(() => import('./room/RoomFixtures'));

// Local spec route. Not linked from the nav. Each section is a desktop
// capture target for frontend/public/art/modules/. The public pages render
// the same stages; these PNGs are the reference, not the page.

const SHOTS = [
  ['nqube', 'nQube', NqubeStage],
  ['athena', 'Athena', AthenaStage],
  ['listen', 'Listen', ListenStage],
  ['devops', 'DevOps', DevOpsStage],
  ['dev-console', 'Dev Console', DevConsoleStage],
  ['app-builder', 'App Builder', AppBuilderStage],
];

export default function StageFixtures() {
  const host = window.location.hostname;
  if (host !== 'localhost' && host !== '127.0.0.1') return <Navigate to="/" replace />;
  const room = new URLSearchParams(window.location.search).get('room');
  if (room) return <Suspense fallback={<div className="room"><div className="room-state">loading the room…</div></div>}><RoomFixtures kind={room} /></Suspense>;

  return (
    <div className="st-fixtures">
      {SHOTS.map(([id, title, Stage]) => (
        <section key={id} id={id} className="st-shot">
          <h2>{title}</h2>
          <Stage />
        </section>
      ))}
      <section id="review" className="st-shot">
        <h2>Review</h2>
        <ReviewCard decided={false} />
      </section>
      {/* The share card (public/art/og-gate.png, 1200×630): the gate and the
          receipt at the final frame of the homepage spine. */}
      <section id="og" className="st-shot">
        <h2>OG · the gate</h2>
        <div className="st-og">
          <div className="st-og-copy">
            <span className="st-og-brand">nventr</span>
            <h3>The bridge to the systems you use, and the apps you build.</h3>
            <p>Your agents can propose the work. They cannot write it. A person or a rule says yes; the runtime writes, with a receipt.</p>
            <span className="st-og-url">nventr.io/gate</span>
          </div>
          <div className="st-og-art">
            <div className="spine-art"><GatePanel t={TIMELINE.length} /></div>
            <div className="spine-art"><ReceiptCard t={TIMELINE.length} at={TIMELINE.commit.at} /></div>
          </div>
        </div>
      </section>
      {/* The gated /concepts/ambient-screen figures (`screen:<id>`). */}
      {Object.entries(AMBIENT_SCREENS).map(([id, Screen]) => (
        <section key={id} id={id} className="st-shot">
          <h2>Ambient · {id}</h2>
          <Screen />
        </section>
      ))}
    </div>
  );
}
